import type { SearchFilterValueDto } from '../types/search-filter-value-dto.type';

export const parseNumber = (
  options: SearchFilterValueDto[] | null,
  id: string,
): number | null => {
  if (!options) {
    return null;
  }

  const value = Number(options.find((option) => option.id === id)?.name);

  return Number.isNaN(value) ? null : value;
};
